import { put } from "@redux-saga/core/effects";
// import { undo } from "../../../helpers/undoable";

import { updateOptionFailure } from "../actionCreaters";

import { FieldsService } from "./../../../services/fields";
import { UpdateOptionRequestActionType } from "./../types";

export function* updateOptionSaga({ payload: { fieldId, optionId, option } }: UpdateOptionRequestActionType) {
    try {
        yield FieldsService.updateOption(fieldId, optionId, option);
    } catch (error) {
        // yield put(undo({ type: SelectableOptionsActionTypes.UPDATE_OPTION }));
        yield put(updateOptionFailure({ fieldId, optionId }));
    }
}
